(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["duryn-test-assets"] && !Shopify.designMode) return;
  try {
    (()=>{
  'use strict';
  if(window.DurynEditableTesting){window.DurynEditableTesting.refresh();return;}
  let root=null;
  let state={query:'',mode:'all',beforeFilter:new Map(),filtering:false};
  let controller=null;
  let scheduled=false;
  const fmt=(text,values)=>String(text||'').replace(/\[(\w+)\]/g,(_,key)=>String(values[key]??''));
  const normalize=value=>String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const els=selector=>Array.from(root?.querySelectorAll(selector)||[]);
  const groups=()=>els('[data-dte-group]');
  const tools=()=>root?.querySelector('[data-dte-tools]');
  const countResults=rows=>rows.filter(row=>row.dataset.status==='published').length;
  function icon(){
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    for(const [key,value] of Object.entries({class:'dt-duryn-arrow',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.8','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'}))svg.setAttribute(key,value);
    const circle=document.createElementNS(svg.namespaceURI,'circle');circle.setAttribute('cx','12');circle.setAttribute('cy','12');circle.setAttribute('r','10.1');
    const path=document.createElementNS(svg.namespaceURI,'path');path.setAttribute('d','M8.4 15.6 15.6 8.4M8.6 8.4h7v7');svg.append(circle,path);return svg;
  }
  function makeNav(){
    const list=root.querySelector('[data-dte-nav]');if(!list)return;
    list.replaceChildren();
    groups().forEach((group,index)=>{
      const link=document.createElement('a');link.href='#'+group.id;link.dataset.dteJump=group.id;
      const number=document.createElement('span');number.className='dt-nav-index';number.textContent=String(index+1).padStart(2,'0');
      const label=document.createElement('span');label.textContent=group.dataset.navTitle;
      link.append(number,label,icon());list.append(link);
    });
  }
  function layout(){
    root.querySelector(':scope > .dte-sidebar')?.remove();
    const sections=Array.from(root.children).filter(el=>el.classList.contains('shopify-section'));
    const groupSections=sections.filter(el=>el.classList.contains('dte-group-section'));
    const visible=groupSections.filter(el=>!el.hidden);
    sections.forEach(el=>{el.style.gridRow='';el.classList.remove('dte-last-group')});
    visible.at(-1)?.classList.add('dte-last-group');
    const source=root.querySelector('[data-dte-nav-source]');
    const indexes=groupSections.map(el=>sections.indexOf(el));
    const contiguous=indexes.length>0&&indexes.every((n,i)=>i===0||n===indexes[i-1]+1);
    const useSidebar=contiguous&&!!source&&visible.length>0&&matchMedia('(min-width:901px)').matches;
    root.classList.toggle('dte-side-layout',useSidebar);
    if(!useSidebar)return;
    const visibleSections=sections.filter(el=>!el.hidden);
    visibleSections.forEach((el,index)=>el.style.gridRow=String(index+1));
    const start=visibleSections.indexOf(visible[0])+1;
    const end=visibleSections.indexOf(visible.at(-1))+2;
    const aside=document.createElement('aside');aside.className='dte-sidebar';aside.style.gridRow=`${start} / ${end}`;aside.setAttribute('aria-label',tools()?.dataset.navLabel||'');
    const content=source.cloneNode(true);content.removeAttribute('data-dte-nav-source');content.className='dt-category-nav';content.querySelector('[data-dte-nav]')?.removeAttribute('data-dte-nav');
    aside.append(content);root.append(aside);
  }
  function updateExpand(){
    const visible=groups().filter(g=>!g.closest('.shopify-section')?.hidden);
    const allOpen=visible.length>0&&visible.every(g=>g.open);
    els('[data-dte-expand]').forEach(button=>button.textContent=allOpen?tools()?.dataset.collapseLabel:tools()?.dataset.expandLabel);
  }
  function filter(){
    if(!root)return;
    const list=groups(),q=normalize(state.query.trim()),active=!!q||state.mode!=='all';
    if(active&&!state.filtering){state.beforeFilter=new Map(list.map(g=>[g.id,g.open]))}
    let visibleTopics=0,visibleResults=0,visibleGroups=0;
    const allRows=els('[data-dte-row]');
    const toolbar=tools();
    list.forEach((group,index)=>{
      const rows=Array.from(group.querySelectorAll('[data-dte-row]'));
      let found=0;
      rows.forEach(row=>{
        const match=!q||normalize(row.textContent+' '+group.dataset.navTitle).includes(q);
        row.hidden=!(match&&(state.mode==='all'||row.dataset.status==='published'));
        if(!row.hidden){found++;visibleTopics++;if(row.dataset.status==='published')visibleResults++}
      });
      const container=group.closest('.shopify-section');
      const hidden=active&&found===0;
      if(container)container.hidden=hidden;
      if(!hidden)visibleGroups++;
      if(active&&found>0)group.open=true;
      if(!active&&state.filtering&&state.beforeFilter.has(group.id))group.open=state.beforeFilter.get(group.id);
      group.querySelector('[data-dte-group-number]').textContent=String(index+1).padStart(2,'0');
      if(toolbar)group.querySelector('[data-dte-group-summary]').textContent=fmt(toolbar.dataset.groupFormat,{topics:rows.length,results:countResults(rows)});
    });
    state.filtering=active;
    els('[data-dte-count="groups"]').forEach(el=>el.textContent=String(list.length).padStart(2,'0'));
    els('[data-dte-count="published"]').forEach(el=>el.textContent=String(countResults(allRows)));
    els('[data-dte-mode]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.dteMode===state.mode)));
    els('[data-dte-clear]').forEach(button=>button.hidden=!state.query);
    els('[data-dte-no-matches]').forEach(el=>el.hidden=visibleTopics!==0);
    if(toolbar){
      const template=active?toolbar.dataset.matchFormat:toolbar.dataset.countFormat;
      els('[data-dte-results-count]').forEach(el=>el.textContent=fmt(template,{groups:visibleGroups,topics:visibleTopics,results:visibleResults,other:visibleTopics-visibleResults}));
    }
    layout();updateExpand();
  }
  function reset(){state.query='';state.mode='all';els('[data-dte-search]').forEach(input=>input.value='');filter()}
  function click(event){
    const target=event.target.closest('button,a');if(!target)return;
    if(target.matches('[data-dte-clear]')){state.query='';els('[data-dte-search]').forEach(input=>input.value='');filter();root.querySelector('[data-dte-search]')?.focus()}
    if(target.matches('[data-dte-reset]')){reset();root.querySelector('[data-dte-search]')?.focus()}
    if(target.matches('[data-dte-mode]')){state.mode=target.dataset.dteMode;filter()}
    if(target.matches('[data-dte-expand]')){const visible=groups().filter(g=>!g.closest('.shopify-section')?.hidden);const expand=!visible.every(g=>g.open);visible.forEach(g=>g.open=expand);updateExpand()}
    if(target.matches('[data-dte-jump]')){
      const group=document.getElementById(target.dataset.dteJump);
      if(group?.closest('.shopify-section')?.hidden)reset();
      if(group)group.open=true;
      els('[data-dte-jump]').forEach(link=>link.removeAttribute('aria-current'));
      els('[data-dte-jump]').filter(link=>link.dataset.dteJump===target.dataset.dteJump).forEach(link=>link.setAttribute('aria-current','true'));
    }
    if(target.getAttribute('href')==='#source-scope'){const scope=root.querySelector('#source-scope');if(scope)scope.open=true}
  }
  function bind(){
    controller?.abort();controller=new AbortController();const signal=controller.signal;
    root.addEventListener('click',click,{signal});
    root.addEventListener('input',e=>{if(e.target.matches('[data-dte-search]')){state.query=e.target.value;filter()}},{signal});
    root.addEventListener('toggle',e=>{if(e.target.matches('[data-dte-group]'))updateExpand()},{capture:true,signal});
  }
  function refresh(){
    const next=document.getElementById('duryn-testing');if(!next)return;
    if(next!==root){root=next;state={query:'',mode:'all',beforeFilter:new Map(),filtering:false};bind()}
    els('[data-dte-search]').forEach(input=>input.value=state.query);
    makeNav();filter();
  }
  function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;refresh()})}
  window.DurynEditableTesting={refresh,reset};
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
  document.addEventListener('shopify:section:reorder',schedule);
  document.addEventListener('shopify:section:select',e=>{if(e.target?.querySelector('[data-dte-group]')){reset();e.target.querySelector('[data-dte-group]').open=true}});
  document.addEventListener('shopify:block:select',e=>{
    if(!root||!root.contains(e.target))return;
    reset();
    const ancestors=[];let el=e.target;while(el&&el!==root){if(el.matches('details'))ancestors.push(el);el=el.parentElement}ancestors.forEach(d=>d.open=true);
    e.target.closest('[data-dte-group]')?.setAttribute('open','');
  });
  window.addEventListener('resize',schedule,{passive:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
